var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$myShift || _vm.$ShiftsToActivate
    ? _c("div", { staticClass: "flex shift_info" }, [
        _c("div", [
          _c("p", [
            _c("strong", [
              _vm._v(
                _vm._s(
                  (_vm.$myShift &&
                    _vm.$myShift.shift &&
                    _vm.$myShift.shift.title) ||
                    "Не активный"
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [_vm._v("Моя смена")]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-2" },
          [
            _vm.$myShift
              ? _c(
                  "v-popover",
                  {
                    attrs: {
                      popoverClass: "work_shift_popover",
                      popoverInnerClass: "popover_content",
                      trigger: "hover",
                      "auto-hide": true,
                    },
                  },
                  [
                    _c("div", { staticClass: "popover_icon" }, [
                      _c("i", { staticClass: "icon-fa icon-fa-info" }),
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "popover" }, [
                      _c("div", {}, [
                        _vm.$myShift
                          ? _c("p", [
                              _vm._v("Активировна с: "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.moment(_vm.$myShift.created_at, "HH:mm")
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [_vm._v("Мои доступы")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(_vm.$orderAccess, function (access, project) {
                            return _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    project === "all"
                                      ? "Все проекты"
                                      : (_vm.$AllProjects[project] &&
                                          _vm.$AllProjects[project].name) ||
                                          "Не определен"
                                  )
                                ),
                              ]),
                              _vm._v(
                                ":\n              " +
                                  _vm._s(
                                    access.all
                                      ? "Все направления"
                                      : (_vm.$AllCities[
                                          Object.keys(access)[0]
                                        ] &&
                                          _vm.$AllCities[Object.keys(access)[0]]
                                            .name) ||
                                          "не определен"
                                  ) +
                                  "\n            "
                              ),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("Активные "),
                          _c("strong", [_vm._v("SIP")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(_vm.$PhoneNumbers.sipAccounts, function (sip) {
                            return _c("p", [
                              _vm._v(_vm._s(_vm.printSip(sip.sip_login))),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-warning",
                              on: { click: _vm.closeShift },
                            },
                            [_vm._v("Закрыть смену")]
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.$myShift &&
            _vm.$ShiftsToActivate &&
            _vm.getActualShift().length
              ? _c(
                  "v-popover",
                  {
                    attrs: {
                      popoverClass: "work_shift_activation_popover",
                      popoverInnerClass: "popover_content",
                      trigger: "hover",
                      open: _vm.openPopover,
                      "auto-hide": false,
                    },
                  },
                  [
                    _c("div", {}),
                    _vm._v(" "),
                    _c("template", { slot: "popover" }, [
                      _c(
                        "div",
                        {},
                        [
                          _vm.shiftsForSelect && _vm.shiftsForSelect.length
                            ? [
                                _vm._v(
                                  "\n            Выберите смену для активации!\n          "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(_vm.shiftsForSelect, function (shift) {
                              return _c(
                                "div",
                                [
                                  _c("LoadingButton", {
                                    attrs: {
                                      title:
                                        shift.title +
                                        ` (${shift.start} - ${shift.end})`,
                                      className: "btn btn-default",
                                      loading: _vm.loading,
                                      color: "#02a2f8",
                                      onClick: () => _vm.activateShift(shift),
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        2
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }